export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';
export const REMOVE_LOGIN_DATA = 'REMOVE_LOGIN_DATA';
export const SET_PAN_DATA = 'SET_PAN_DATA';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SET_BANK_LIST = 'SET_BANK_LIST';
export const SHOW_HEDER_OPTIONS = 'SHOW_HEDER_OPTIONS';
export const NAV_SELECTION_CHANGE = 'NAV_SELECTION_CHANGE';
export const APP_CONFIG = 'APP_CONFIG';
